import type { Media, Product, Variant } from '@/payload-types'

/**
 * Картинка товара: у варианта — своя, если в галерее есть снимок, привязанный
 * к одной из его опций (например, чёрная футболка), иначе первая из галереи,
 * иначе картинка из SEO-блока.
 */
export function productImage(product: Product, variant?: Variant | null): Media | undefined {
  const gallery = product.gallery ?? []

  if (variant) {
    const match = gallery.find((entry) => {
      if (!entry.variantOption) return false
      const optionID = typeof entry.variantOption === 'object' ? entry.variantOption.id : entry.variantOption
      return variant.options?.some((option) => (typeof option === 'object' ? option.id : option) === optionID)
    })
    if (match && typeof match.image === 'object' && match.image) return match.image
  }

  const first = typeof gallery[0]?.image === 'object' ? gallery[0]?.image : undefined
  const meta = product.meta?.image && typeof product.meta.image === 'object' ? product.meta.image : undefined

  return first ?? meta ?? undefined
}
